import axios from 'axios';

export async function checkAppDownloadCode(signupCode : string) {
    return await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/common/resource/verification?code=${signupCode}`);
}